
export default class ScanLine{

    constructor() {
        this.scanlineElm = document.querySelector('.js-scanline');
    }


    setup(){
        this._setupScanLine();
    }


    /**
     * 走査線のエフェクトをセットする
     */
    _setupScanLine() {
        const delay = Math.max(5000, Math.floor(Math.random() * 15000));

        setTimeout(() => {
            this._setupScanLine();
            if(!this.scanlineElm.classList.contains('-repeat')){
                this.scanlineElm.classList.add('-repeat');
            }
        }, delay);

        this._startScanlineAnime();
    }

1
    /**
     * 走査線のアニメーションを開始する
     */
    _startScanlineAnime() {
        this.scanlineElm.classList.remove('-playing');

        setTimeout(() => {
            this.scanlineElm.classList.add('-playing');
        }, 500);
    }
}